<div class="ewallet-wrapper">
    <div class="ewallet-user-details">
        <div class="ewallet-user-details-left with-innerToast">
            <div class="profile-icon" data-dd-privacy="mask">{{initials}}</div>
            <div class="profile-data">
                <div class="name">
                    <h2 class="title" data-dd-privacy="mask">{{name}}</h2>
                </div>
                <div class="sub-text">
                    <span data-dd-privacy="mask">{{content?.['b2b.booking.employeecode'] || 'Employee code'}}  {{employeeCode}}  <ng-container *ngIf="designation">| {{designation}}</ng-container></span>
                </div>
            </div>
        </div>
    </div>
</div>